import type { IconNode } from '../types';

/**
 * @name sneaker
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQuMSA3LjkgMTIuNSAxMCIgLz4KICA8cGF0aCBkPSJNMTcuNCAxMC4xIDE2IDEyIiAvPgogIDxwYXRoIGQ9Ik0yIDE2YTIgMiAwIDAgMCAyIDJoMTNjMi44IDAgNS0yLjIgNS01YTIgMiAwIDAgMC0yLTJjLS44IDAtMS42LS4yLTIuMi0uN2wtNi4yLTQuMmMtLjQtLjMtLjktLjItMS4zLjEgMCAwLS42LjgtMS4yIDEuMWEzLjUgMy41IDAgMCAxLTQuMi4xQzQuNCA3IDMuNyA2LjMgMy43IDYuM0EuOTIuOTIgMCAwIDAgMiA3WiIgLz4KICA8cGF0aCBkPSJNMiAxMWMwIDEuNyAxLjMgMyAzIDNoNyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/sneaker
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const sneaker: IconNode = [
  ['path', { d: 'M14.1 7.9 12.5 10', key: '1omg66' }],
  ['path', { d: 'M17.4 10.1 16 12', key: 'klmssx' }],
  [
    'path',
    {
      d: 'M2 16a2 2 0 0 0 2 2h13c2.8 0 5-2.2 5-5a2 2 0 0 0-2-2c-.8 0-1.6-.2-2.2-.7l-6.2-4.2c-.4-.3-.9-.2-1.3.1 0 0-.6.8-1.2 1.1a3.5 3.5 0 0 1-4.2.1C4.4 7 3.7 6.3 3.7 6.3A.92.92 0 0 0 2 7Z',
      key: '1y12pk',
    },
  ],
  ['path', { d: 'M2 11c0 1.7 1.3 3 3 3h7', key: '1aw5u0' }],
];

export default sneaker;
